import { Component, ComponentOptions } from "./component";
import { Container } from "./container";
import { ContentContainer } from "./contentContainer";
import { UserComponent } from "./userComponent";

const view = () => new Container({
    components: [
        new ContentContainer({
            property: "toolbar"
        }),
        new Container({
            classes: "sub-screen",
            components: [
                new Container({
                    id: "Workspace",
                    classes: "workspace container",
                    style: "opacity: 1; display: block; padding-top: 32px;",
                    components: [
                        new Container({
                            classes: "maintenance",
                            components: [
                                new ContentContainer({
                                    property: "workspace"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    ]
});

export interface SubScreenLayoutOptions extends ComponentOptions {
    toolbar?: Component[];
    workspace?: Component[];
}

export class SubScreenLayout extends UserComponent {

    options: SubScreenLayoutOptions;
    content: {
        toolbar: Component[];
        workspace: Component[];
    };

    constructor(options: SubScreenLayoutOptions) {
        super(view, options);

        this.content = {
            toolbar: options.toolbar || [],
            workspace: options.workspace || []
        };

        this.isLayout = true;
    }

    create() {
        if (this.content.toolbar.length == 0) {
            this.view.get("#Workspace").css("padding-top", 0);
        }
    }

}
